<template>
  <div id="app">
    <router-view :key="$route.query.columnId"/>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  mounted() {
    window.addEventListener('beforeunload', this.closeMask)
    this.$once('hook:beoforeDestroy', this.closeMask)
  },
  destroyed() {
    this.closeMask()
  },
  methods: {
    closeMask () {
      sessionStorage.removeItem('banner')
      sessionStorage.removeItem('reportList')
      sessionStorage.removeItem('documentList')
    }
  }
}
</script>
<style>
@import "./style/common.css";
</style>
